<template>
  <section class="wrapper">
    <van-form @submit="save">
      <van-field
        input-align="right"
        v-model="applyInfo.ActApply"
        label="申请人"
        placeholder="请输入"
        :rules="[{ required: true, message: '请输入' }]"
        clearable
      >
        <template #button>
          <van-button block type="info" native-type="button" class="van-field_dosth" @click="showAgencyPicker=true">代办</van-button>
        </template>
      </van-field>
      <van-field
        is-link
        input-align="right"
        v-model="applyInfo.Post.text"
        label="发起岗位"
        readonly
        placeholder="请选择"
        :rules="[{ required: true, message: '请选择' }]"
        @click="showPostPicker=true"
      />
      <van-field
        input-align="right"
        v-model="applyInfo.summary"
        rows="1"
        autosize
        label="摘要"
        type="textarea"
      />
      <van-collapse v-model="activeNames">
        <div class="van-remove-detail-items" v-for="(detail,index) in applyInfo.details" :key="index">
          <label class="van-remove-detail" v-if="index>0"><i class="iconfont iconfont-guanbi iconfont-style" @click="removeDetails(index)"></i></label>
          <van-collapse-item :title="`报销明细${index+1}`" :name="index">
            <van-field input-align="right" label="说明附件">
              <template #input>
                <van-uploader v-model="detail.uploader" :after-read="(file)=>{
                  //自行上传文件
                  detail.uploader.forEach((item, index) => {
                    //此时可以自行将文件上传至服务器
                    fileUpload(item.file,detail);
                  })
                }" multiple>
                  <van-button size="small" icon="plus" round plain type="primary"/>
                </van-uploader>
              </template>
            </van-field>
            <van-field
              is-link
              input-align="right"
              v-model="detail.OrganizationName"
              label="负担部门"
              readonly
              placeholder="请选择负担部门"
              @click="showBurdenDepartmentModal(detail)"
              :rules="[{ required: false }]"
            />
            <van-field
              is-link
              input-align="right"
              v-model="detail.AffirmDate"
              label="发生日期"
              readonly
              placeholder="请选择日期"
              @click="detail.showWindows.showDatePicker=true"
              :rules="[{ required: true, message: '请选择日期' }]"
            />
            <van-field
              is-link
              input-align="right"
              v-model="detail.ShowInvType"
              readonly
              label="详细类别"
              placeholder="请先选择费用类别"
              :rules="[{ required: true, message: '请选择' }]"
              @click="detail.showWindows.showDtsInvTypePicker=true"
            />
            <van-field
              input-align="right"
              v-model="detail.detailSummary"
              label="明细摘要"
            />
            <van-field
              is-link
              input-align="right"
              v-model="detail.RPer.text"
              label="供应商/交易方"
              readonly
              placeholder="请选择供应商/交易方"
              @click="detail.showWindows.showSupplierPicker=true"
              :rules="[{ required: false }]"
            />
            <van-field
              input-align="right"
              v-model="detail.SumAmount"
              label="含税金额"
              placeholder="请输入"
              type="number"
              @change="(e)=>{
                  detail.SumAmount=parseFloat(e.target.value).toFixed(2)
                  CalcSumAmount(detail);
                }"
              :rules="[{ required: true, message: '请输入' }]"
            />
            <van-collapse v-model="vatActiveName">
              <van-collapse-item title="VAT专票" :name="1">
                <van-field
                  input-align="right"
                  v-model="detail.Category.text"
                  readonly
                  label="税种"
                  placeholder="请选择"
                  @click="detail.showWindows.showTaxCategoryPicker=true"
                />
                <van-field
                  input-align="right"
                  v-model="detail.TaxationType.text"
                  readonly
                  label="税率"
                  placeholder="请选择"
                  @click="detail.showWindows.showTaxTypePicker=true"
                />
                <van-field
                  input-align="right"
                  v-model="detail.TaxationAmount"
                  label="税费"
                  placeholder="请输入"
                  type="number"
                  @change="(e)=>{
                  CalcTaxAmount(detail);
                }"
                />
                <van-field
                  input-align="right"
                  v-model="detail.Amount"
                  label="金额"
                  placeholder="请输入"
                  type="number"
                  @change="(e)=>{
                  detail.Amount=parseFloat(e.target.value).toFixed(2);
                  CalcAmount(detail);
                }"
                :rules="[{ required: true, message: '请输入' }]"
                />
              </van-collapse-item>
            </van-collapse>
            <van-field
              input-align="right"
              v-model="detail.subsidyAmt"
              label="补助"
              placeholder="请输入"
              type="number"
              @change="(e)=>{
                  sumsubsidyAmt(detail);
                }"
              :rules="[{ required: true, message: '请输入' }]"
            />
            <van-field
              input-align="right"
              v-model="detail.Currency.text"
              readonly
              label="货币"
              placeholder="请选择"
              @click="detail.showWindows.showCurrencyPicker=true"
              :rules="[{ required: true, message: '请选择' }]"
            />
            <!--日期选择器-->
            <van-popup v-model="detail.showWindows.showDatePicker" position="bottom">
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                @cancel="detail.showWindows.showDatePicker=false"
                @confirm="()=>{
                detail.AffirmDate = moment(currentDate).format('YYYY/MM/DD');
                detail.showWindows.showDatePicker = false
              }"
              />
            </van-popup>
            <!--供应商/交易方弹框-->
            <van-popup v-model="detail.showWindows.showSupplierPicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="supplierList"
                @cancel="detail.showWindows.showSupplierPicker = false"
                @confirm="(item,index)=>{
                detail.RPer.value=item.value;
                detail.RPer.text=item.text;
                detail.showWindows.showSupplierPicker = false;
              }"
              />
            </van-popup>
            <!--详细类别弹框-->
            <van-popup v-model="detail.showWindows.showDtsInvTypePicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="dtsInvTypeList"
                @cancel="detail.showWindows.showDtsInvTypePicker = false"
                @change="(picker,values,index)=>{
                //let ColumnIndex = picker.getColumnIndex(index);//第几个数据
                picker.setColumnValues(index+1, values[0]&&values[0].children || []);//点当前列更新下一列数据，防止undefined
                //当然，如果后台数据不给你想要的格式，你就按需请求一次了，比如选中第一个，取id请求接口，更新下一列。毕竟连动内容多的话，页面请求也多。但页面就不流畅，比如第一列第二列初始值。
                //我就是打不过后台。。。
              }"
                @confirm="(value)=>{
               // 三级联动 去除没值的，比如只有两级
                const compact = arr => arr.filter(Boolean);
                const result = compact(value);
                let item = result[result.length - 1]; // 一般都是取最后一个id给后台的
                detail.ShowInvType=item.text;
                detail.InvType=item.id.split('|').length>0?item.id.split('|')[0]:'';
                detail.DtsInvType=item.id.split('|').length>1?item.id.split('|')[1]:'';
                detail.DetailInvType=item.id.split('|').length>2?item.id.split('|')[2]:'';
                detail.showWindows.showDtsInvTypePicker=false;
              }"
              />
            </van-popup>
            <!--税种弹框-->
            <van-popup v-model="detail.showWindows.showTaxCategoryPicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="taxCategoryList"
                @cancel="detail.showWindows.showTaxCategoryPicker = false"
                @confirm="(item,index)=>{
                detail.Category.value=item.value;
                detail.Category.text=item.text;
                categoryChange(item.value,detail);
                detail.showWindows.showTaxCategoryPicker=false;
              }"
              />
            </van-popup>
            <!--税率弹框-->
            <van-popup v-model="detail.showWindows.showTaxTypePicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="detail.taxTypeList"
                @cancel="detail.showWindows.showTaxTypePicker = false"
                @confirm="(item,index)=> {
                detail.TaxationType.value=item.value;
                detail.TaxationType.text=item.text;
                taxChange(detail);
                detail.showWindows.showTaxTypePicker=false;
              }"
              />
            </van-popup>
            <!--货币弹框-->
            <van-popup v-model="detail.showWindows.showCurrencyPicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="currencyList"
                @cancel="detail.showWindows.showCurrencyPicker = false"
                @confirm="(item,index)=> {
                detail.Currency.value=item.value;
                detail.Currency.text=item.text;
                detail.showWindows.showCurrencyPicker=false;
              }"
              />
            </van-popup>
            <!--负担部门弹框-->
            <van-popup v-model="detail.showWindows.showBurdenDepartPicker" round position="bottom">
              <div class="row">
                <div class="row-container">
                    <div class="modal-header"><div class="modal-title">选择负担部门</div></div>
                </div>
                <div class="row-container">
                  <div class="row-border">
                    <div class="col-md-left">
                      <van-field
                        input-align="left"
                        v-model="searchNodeNameKey"
                        label=""
                        placeholder="输入部门/事业部关键字"
                      />
                    </div>
                    <div class="col-md-right">
                      <a class="a-button van-button--primary a-link" @click="searchDepartMentList()">查询</a>
                    </div>
                  </div>
                </div>
                <div class="row-container">
                    <nested-table :data="tableData" @data-from-child="handleDataFromChild"></nested-table>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="wc-btn wc-btn-primary" @click="saveBurdenDepartment(detail)">
                  提交
                </button>
                <button type="button" class="wc-btn wc-btn-primary ghost" @click="detail.showWindows.showBurdenDepartPicker=false">
                  关闭
                </button>
              </div>
            </van-popup>
          </van-collapse-item>
        </div>
      </van-collapse>
      <div class="add-detail" @click="addDetails"><i class="iconfont iconfont-zengjia"></i>添加明细</div>
      <van-row class="total">
        <van-col span="12" class="title">费用总金额</van-col>
        <van-col span="12" class="value"><small>CNY</small><i class="ml5 h4">{{applyInfo.ExpensesAmount}}</i></van-col>
      </van-row>
      <van-row class="total">
        <van-col span="12" class="title">补助总金额</van-col>
        <van-col span="12" class="value"><small>CNY</small><i class="ml5 h4">{{applyInfo.SubsidyAmount}}</i></van-col>
      </van-row>
      <van-divider :style="{ borderColor: '#f6f6f8', margin: '0' }"/>
      <van-row class="total">
        <van-col span="12" class="text-muted">报销总金额</van-col>
        <van-col span="12" class="value text-primary"><small class="ml5">合计 CNY</small><i class="ml5 h3 text-info">{{applyInfo.TotalAmount}}</i>
        </van-col>
      </van-row>
      <div class="buttons">
        <van-button v-show="isShow" type="primary" native-type="submit">提交</van-button>
        <van-button v-show="!isShow" disabled type="primary" native-type="submit">提交</van-button>
        <van-button color="#999999" class="ml10" @click="$router.push('/follow')">返回</van-button>
      </div>
    </van-form>
    <!--用户岗位弹框-->
    <van-popup v-model="showPostPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="postList"
        @cancel="showPostPicker = false"
        @confirm="onPost"
      />
    </van-popup>
    <!--代办弹框是否弹出-->
    <van-popup v-model="showAgencyPicker" round position="bottom">
      <div class="popup-header"><div class="agency-title">选择申请人</div></div>
      <div class="popup-content">
        <!--如果不设置this.list.length>0这个条件的话，load会一直加载-->
        <van-list v-model="agencyLoading" :finished="finished" :finished-text="finishedText"  @load="LoadAgencyList">
          <div class="agency-box">
            <van-row class="th-row">
              <van-col>部门</van-col>
              <van-col>岗位</van-col>
              <van-col>姓名</van-col>
              <van-col>手机号码</van-col>
              <van-col>Email</van-col>
            </van-row>
            <van-row class="tb-row" v-for="(item, index) of list" :key="index" @click="selectAgencyUser(item, index)">
              <van-col>{{ item.DeptName }}</van-col>
              <van-col>{{ item.PostName }}</van-col>
              <van-col>{{ item.Employee }}</van-col>
              <van-col>{{ item.tel }}</van-col>
              <van-col>{{ item.Email }}</van-col>
            </van-row>
          </div>
        </van-list>
      </div>
    </van-popup>
  </section>
</template>

<script>
  // 1.引入
  import NestedTable from '@/components/NestedTable'; // 确保路径正确
  import {getDetailCostTypeOptionsApi,getStaffListNotCurrentApi,getUserPostListApi,getUserPostUserNameApi,submitApplyFormApi,GetDepartmentNodeListApi,checkReimbursementFrequencyLimitApi} from '@/api/reimbursement'
  import {getTaxListByCategoryApi,getSupplierApi,getPartnersAllApi,getSearchCurrencyApi,getTaxOneApi,getDepartmentByPostApi, fileUploadApi,fileUploadStreamApi,checkRateApi} from '@/api/common'
  export default {
    components: {NestedTable},
    data() {
      return {
        isShow: true,//是否显示
        showPostPicker: false,//弹出岗位弹框
        showAgencyPicker: false,//弹出代办人弹框
        currentDate: new Date(),//当前日期
        applyInfo: {
          FormType: 'FB',//业务类型
          Taxpayer: '一般纳税人',//纳税人名称
          ActApply: '',//申请人
          ActApplyU_GUID: '',//申请人GUID
          Post: {text: '', value: ''},//发起岗位
          summary: '',//摘要
          details: [{
            GUID: this.guid(),//生成唯一的GUID
            AffirmDate: '',//发生日期
            OrganizationName: '',//负担部门名称以','拼接字符串
            detailOrganzation: [],//负担部门存储信息
            SelectedIds: [],//负担组织存储ID集合
            InvType: '',//费用类别
            DtsInvType: '',//二级科目类别
            ShowInvType: '',//显示的详细类别
            DetailInvType: '',//三级费用类别
            detailSummary: '',//摘要
            RPer: {text: '', value: ''},//供应商/交易方
            Amount: '',//金额
            Category: {text: '', value: ''},//税种
            TaxationType: {text: '', value: ''},//税率
            TaxationAmount: '',//税费
            SumAmount: '',//含税金额
            subsidyAmt: '0',//补助
            Currency: {text: 'CNY', value: 'CNY'},//货币
            Log: '',//标记
            Log_c: '',//标记C
            State: 0,//状态
            taxTypeList: [
              {text: "请选择", value: ""}
            ],//税率列表
            uploader: [],//需要上传的文件
            fileList: [],//存储上传的文件
            //弹框对象
            showWindows: {
              showDatePicker: false,//日期弹框
              showDtsInvTypePicker: false,//详细类别弹框
              showTaxCategoryPicker: false,//税种弹框
              showTaxTypePicker: false,//税率弹框
              showSupplierPicker: false,//供应商弹框
              showCurrencyPicker: false,//货币弹框
              showBurdenDepartPicker: false,//负担部门弹框
            },
          }],
          ExpensesAmount: '',//费用总金额
          SubsidyAmount: '',//补助总金额
          TotalAmount: '',//报销总金额
        },
        postList: [
          {text: "请选择", value: ""}
        ],//岗位列表
        supplierList: [
          {text: "请选择", value: ""}
        ],//供应商列表
        dtsInvTypeList: [],//详细类别列表
        taxCategoryList: [
          {text: "增值税专用发票", value: "专用发票"},
          {text: "增值税普通发票", value: "普通发票"},
          {text: "离岸发票", value: "离岸发票"}
        ],//税种列表
        currencyList: [
          {text: "请选择", value: ""}
        ],//货币列表
        departmentData: [],//部门数据
        tableData: [],//部门以嵌套表格显示数据
        searchNodeNameKey: '',//部门/事业部关键字
        selectedDepartData: [],//存储已选择的负担部门数据
        selectedCheckBoxGroup: [],//传给子级已选择的数据
        activeNames: [0],//报销明细分组名称
        vatActiveName: [],//VAT专票分组名称
        rateInfo: {key: '', value: ''},//单个税率值
        list: [],//代办人列表数据
        agencyLoading: false, // 加载状态
        finished: false, // 是否加载
        finishedText: '',
        pages: 0, // 页数
        pagesize: 10, // 条数
      }
    },
    created() {
      this.getUserPostList();
      this.getSearchCurrency();
    },
    mounted() {
      this.getDetailCostTypeOptions();
      this.getDepartmentNodeList();
      this.getSupplier();
    },
    methods: {
      //加载分页数据
      LoadAgencyList() {
        this.pages += 1; // 页数+1
        this.getStaffListNotCurrent();
      },
      //获取职工人员列表
      async getStaffListNotCurrent() {
        this.finishedText = '';
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let uGuid = this.applyInfo.ActApplyU_GUID === undefined || this.applyInfo.ActApplyU_GUID === null || this.applyInfo.ActApplyU_GUID === '' ? userInfo.U_GUID : this.applyInfo.ActApplyU_GUID;
        let params = {
          cGuid: companyInfo.companyId,
          uGuid: uGuid
        };
        let response = await getStaffListNotCurrentApi(params);
        if (response.success) {
          if (response.code === "0000") {
            this.agencyLoading = false
            if (response.result.length > 0) {
              this.list = this.list.concat(response.result) // 追加数据
              this.finished = false;
              //这里暂时不需要分页所以将每页条数和总条数保持一致即可
              this.pagesize = this.list.length;
              // 如果当前页数 = 总页数，则已经没有数据
              if (this.pages === Math.ceil(this.list.length / this.pagesize)) {
                this.finished = true
                this.finishedText = '- 没有更多了-'
              }
              return;
            }
            this.finished = true
            this.finishedText = '-暂无数据-'
            return;
          }
          this.finished = true
          this.finishedText = '- 数据异常-'
          return;
        }
      },
      //选择申请人信息
      selectAgencyUser(item, index) {
        this.postList = [];
        let data = new Object();
        data.text = item.PostName;
        data.value = item.PostsetGUID;
        this.postList.push(data);
        this.$set(this.applyInfo.Post, 'value', item.PostsetGUID);
        if (item.DeptName === undefined || item.DeptName === null || item.DeptName === "") {
          this.$set(this.applyInfo.Post, 'text', item.PostName);
        } else {
          this.$set(this.applyInfo.Post, 'text', item.DeptName + '/' + item.PostName);
        }
        this.$set(this.applyInfo, 'ActApply', item.Employee);
        this.$set(this.applyInfo, 'ActApplyU_GUID', item.U_GUID);
        this.showAgencyPicker = false;
      },
      //选择岗位
      onPost(item) {
        this.$set(this.applyInfo.Post, 'value', item.value);
        this.$set(this.applyInfo.Post, 'text', item.text);
        this.getUserPostUserName(this.applyInfo.Post.value);
        this.getDepartmentByPost(this.applyInfo.Post.value);
        this.showPostPicker = false;
      },
      //获取用户岗位列表
      async getUserPostList() {
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cGuid: companyInfo.companyId,
          uGuid: userInfo.U_GUID
        };
        let response = await getUserPostListApi(params);
        if (response.success) {
          if (response.code === "0000") {
            let arr = new Array();
            response.result.forEach(function (item, index) {
              let data = new Object();
              data.text = item.PostName;
              data.value = item.GUID;
              arr.push(data);
            });
            if (arr != undefined && arr != null && arr.length > 0) {
              this.postList = arr;
              this.$set(this.applyInfo.Post, 'value', arr[0].value);
              this.$set(this.applyInfo.Post, 'text', arr[0].text);
              this.getUserPostUserName(this.applyInfo.Post.value);
              this.getDepartmentByPost(this.applyInfo.Post.value);
            }
          }
        }
      },
      //获取岗位人员名称
      async getUserPostUserName(postGuid) {
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cGuid: companyInfo.companyId,
          uGuid: userInfo.U_GUID,
          postGuid: postGuid
        };
        let response = await getUserPostUserNameApi(params);
        if (response.success) {
          if (response.code === "0000") {
            this.applyInfo.ActApply = response.result;
          }
        }
      },
      //获取负担组织部门列表
      async getDepartmentNodeList() {
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cGuid: companyInfo.companyId
        };
        let response = await GetDepartmentNodeListApi(params);
        if (response.success) {
          if (response.code === "0000") {
            this.departmentData = response.result;
          }
        }
      },
      //根据岗位GUID获取当前所属的部门
      async getDepartmentByPost(postGuid) {
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cGuid: companyInfo.companyId,
          postGuid: postGuid
        };
        let response = await getDepartmentByPostApi(params);
        if (response.success) {
          if (response.code === "0000") {
            let str = "";
            let array = new Array();
            this.applyInfo.details.forEach((item, index) => {
              str = response.result.NodeName;
              let obj = new Object();
              this.$set(obj, "nodeid", response.result.NodeID);
              this.$set(obj, "nodename", response.result.NodeName);
              this.$set(obj, "nodeamount", "");
              this.$set(obj, "nodeparent", response.result.ParentID);
              this.$set(obj, "nodechecked", true);
              array.push(obj);
              this.$set(item, "OrganizationName", str);
              this.$set(item, "detailOrganzation", array);
            });
          }
        }
      },
      //弹出负担组织弹框
      showBurdenDepartmentModal(detail) {
        this.selectedDepartData = new Array();
        this.searchNodeNameKey = '';
        //显示一下已选择的负担部门
        if (detail.detailOrganzation && detail.detailOrganzation !== null && detail.detailOrganzation.length > 0) {
          let arrayStr = detail.detailOrganzation;
          arrayStr.forEach((item, index) => {
            let obj = new Object();
            this.$set(obj, "nodeid", item.nodeid);
            this.$set(obj, "nodename", item.nodename);
            this.$set(obj, "nodeamount", item.nodeamount);
            this.$set(obj, "nodeparent", item.nodeparent);
            this.$set(obj, "nodechecked", item.nodechecked);
            this.selectedDepartData.push(obj);
          })
        }
        this.showDepartTreeData(detail, '');
        detail.showWindows.showBurdenDepartPicker = true;
      },
      //将部门以tree形式显示
      showDepartTreeData(detail, nodename) {
        let arrayList = new Array();
        let list = this.departmentData;
        if (nodename && nodename != null && nodename != "") {
          list = this.departmentData.filter(o => o.NodeName.indexOf(nodename) > 0);
        }
        let minObject = list.reduce((min, current) => (current.Level < min.Level ? current : min), list[0]);
        let minLevel = minObject.Level;
        let jsonData = list.filter(o => o.Level == minLevel);
        if (jsonData && jsonData != null && jsonData.length > 0) {
          jsonData.forEach((item, index) => {
            let obj = new Object();
            this.$set(obj, "id", item.NodeID);
            this.$set(obj, "label", item.NodeName);
            this.$set(obj, "value", !this.selectedDepartData || this.selectedDepartData === null || this.selectedDepartData.length < 1 ? "" : this.selectedDepartData.filter(o => o.nodeid === item.NodeID) !== null && this.selectedDepartData.filter(o => o.nodeid === item.NodeID).length > 0 ? this.selectedDepartData.filter(o => o.nodeid === item.NodeID)[0].nodeamount : "");
            this.$set(obj, "parentid", item.ParentID);
            this.$set(obj, "expanded", !this.selectedDepartData || this.selectedDepartData === null || this.selectedDepartData.length < 1 ? false : this.selectedDepartData.filter(o => o.nodeparent === item.NodeID) !== null && this.selectedDepartData.filter(o => o.nodeparent === item.NodeID).length > 0 ? true : false);
            this.$set(obj, "checked", !this.selectedDepartData || this.selectedDepartData === null || this.selectedDepartData.length < 1 ? false : this.selectedDepartData.filter(o => o.nodeid === item.NodeID) !== null && this.selectedDepartData.filter(o => o.nodeid === item.NodeID).length > 0 ? this.selectedDepartData.filter(o => o.nodeid === item.NodeID)[0].nodechecked : false);
            //检查该节点是否有子节点
            let child = list.filter(o => o.ParentID == item.NodeID);
            if (child && child != null && child.length > 0) {
              this.bindChildDepartData(detail, obj, list, child);
            }
            arrayList.push(obj);
          })
        }
        this.$set(this, "tableData", arrayList);
      },
      //循环绑定子级部门数据
      bindChildDepartData(detail, object, list, childs) {
        let arrayList = new Array();
        childs.forEach((item, index) => {
          let obj = new Object();
          this.$set(obj, "id", item.NodeID);
          this.$set(obj, "label", item.NodeName);
          this.$set(obj, "value", !this.selectedDepartData || this.selectedDepartData === null || this.selectedDepartData.length < 1 ? "" : this.selectedDepartData.filter(o => o.nodeid === item.NodeID) !== null && this.selectedDepartData.filter(o => o.nodeid === item.NodeID).length > 0 ? this.selectedDepartData.filter(o => o.nodeid === item.NodeID)[0].nodeamount : "");
          this.$set(obj, "parentid", item.ParentID);
          this.$set(obj, "expanded", !this.selectedDepartData || this.selectedDepartData === null || this.selectedDepartData.length < 1 ? false : this.selectedDepartData.filter(o => o.nodeparent === item.NodeID) !== null && this.selectedDepartData.filter(o => o.nodeparent === item.NodeID).length > 0 ? true : false);
          this.$set(obj, "checked", !this.selectedDepartData || this.selectedDepartData === null || this.selectedDepartData.length < 1 ? false : this.selectedDepartData.filter(o => o.nodeid === item.NodeID) !== null && this.selectedDepartData.filter(o => o.nodeid === item.NodeID).length > 0 ? this.selectedDepartData.filter(o => o.nodeid === item.NodeID)[0].nodechecked : false);
          let child = this.departmentData.filter(o => o.ParentID == item.NodeID);
          if (child && child != null && child.length > 0) {
            this.bindChildDepartData(detail, obj, list, child);
          }
          arrayList.push(obj);
        })
        this.$set(object, "children", arrayList);
      },
      //搜索查询负担部门
      searchDepartMentList(detail) {
        let searchKey = !this.searchNodeNameKey || this.searchNodeNameKey === null || this.searchNodeNameKey === "" ? "" : this.searchNodeNameKey;
        this.showDepartTreeData(detail, searchKey);
      },
      //接收一下子级传过来的数据
      handleDataFromChild(data) {
        //如果是数组的话则按照数组处理
        if (Array.isArray(data)) {
          data.forEach((item, i) => {
            let obj = new Object();
            obj.nodeid = item.id;
            obj.nodename = item.label;
            obj.nodeamount = item.value;
            obj.nodeparent = item.parentid;
            obj.nodechecked = item.checked;
            // 是否可以找到对象的索引
            let index = this.selectedDepartData.findIndex(o => o.nodeid === item.id);
            // 如果找到则编辑该对象
            if (index > -1) {
              //如果已存在并且是选中的话则更新一下数组，否则删除
              if (item.checked) {
                this.$set(this.selectedDepartData, index, obj);
              } else {
                this.selectedDepartData.splice(index, 1);
              }
            } else {
              //选中的数组才加入数组中
              if (item.checked) {
                this.selectedDepartData.push(obj);
              }
            }
          })
        } else {
          let item = data;
          let obj = new Object();
          obj.nodeid = item.id;
          obj.nodename = item.label;
          obj.nodeamount = item.value;
          obj.nodeparent = item.parentid;
          obj.nodechecked = item.checked;
          // 是否可以找到对象的索引
          let index = this.selectedDepartData.findIndex(o => o.nodeid === item.id);
          // 如果找到则编辑该对象
          if (index > -1) {
            //如果已存在并且是选中的话则更新一下数组，否则删除
            if (item.checked) {
              this.$set(this.selectedDepartData, index, obj);
            } else {
              this.selectedDepartData.splice(index, 1);
            }
          } else {
            //选中的数组才加入数组中
            if (item.checked) {
              this.selectedDepartData.push(obj);
            }
          }
        }
      },
      //保存已选择的负担部门
      saveBurdenDepartment(detail) {
        let jsonStr = "";
        let str = "";
        let array = this.selectedDepartData.filter(o => o.nodechecked);
        if (!array || array === null || array.length < 1) {
          this.$toast.fail('至少选择一个分担组织！');
          return;
        }
        if (array.length > 1 && array.filter(o => !o.nodeamount || o.nodeamount === null || o.nodeamount === "" || o.nodeamount.length < 1 || o.nodeamount === "0").length > 0) {
          this.$toast.fail('请输入分担金额！');
          return;
        }
        array.forEach((item, index) => {
          str += !str || str === null || str === "" ? item.nodename : "," + item.nodename;
        });
        detail.OrganizationName = str;
        detail.detailOrganzation = array;
        detail.showWindows.showBurdenDepartPicker = false
      },
      //获取详细类别下拉选项
      async getDetailCostTypeOptions() {
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cGuid: companyInfo.companyId
        };
        let response = await getDetailCostTypeOptionsApi(params);
        if (response.success) {
          if (response.code === "0000") {
            this.dtsInvTypeList = [{
              values: response.result,
              className: "column1"
            }, {values: response.result[0].children, className: "column2"}]
          }
        }
      },
      //根据税种获取税率
      async getTaxTypeByCategory(category, taxPayer) {
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cGuid: companyInfo.companyId,
          TaxPayer: taxPayer,
          Category: category
        };
        let response = await getTaxListByCategoryApi(params);
        if (response.success) {
          if (response.code === "0000") {
            let arr = new Array();
            response.result.forEach(function (item, index) {
              //item 就是当日按循环到的对象
              //index是循环的索引，从0开始
              let data = new Object();
              if (item.Rate == "0") {
                data.text = "其它税率";
              } else {
                data.text = item.Rate + "%";
              }
              data.value = item.T_GUID;
              arr.push(data);
            });
            return arr;
          }
          return [{text: '请选择', value: ''}];
        }
        return [{text: '请选择', value: ''}];
      },
      //获取供应商数据
      async getSupplier() {
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cGuid: companyInfo.companyId,
          uGuid: userInfo.U_GUID
        };
        let response = await getSupplierApi(params);
        if (response.success) {
          if (response.code === "0000") {
            let arr = new Array();
            response.result.forEach(function (item, index) {
              //item 就是当日按循环到的对象
              //index是循环的索引，从0开始
              if (item.Name !== "-") {
                let data = new Object();
                data.text = item.Name;
                data.value = item.BP_GUID;
                arr.push(data);
              }
            });
            this.supplierList = arr;
          }
        }
      },
      //获取币值种类
      async getSearchCurrency() {
        let response = await getSearchCurrencyApi();
        if (response.success) {
          if (response.code === "0000") {
            let arr = new Array();
            response.result.forEach(function (item, index) {
              //item 就是当日按循环到的对象
              //index是循环的索引，从0开始
              let data = new Object();
              data.text = item.Code;
              data.value = item.Code;
              arr.push(data);
            });
            this.currencyList = arr;
          }
        }
      },
      //上传至服务器
      async fileUpload(file, detail) {
        //此时可以自行将文件上传至服务器
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let formData = new FormData();
        formData.append("cGuid", companyInfo.companyId);
        formData.append("uGuid", userInfo.U_GUID);
        formData.append("frGuid", detail.GUID);
        formData.append("TempFileNameFirst", "1");
        formData.append("Type", "OCR");
        formData.append("sequence", detail.GUID);
        formData.append("RelationType", "FB");
        formData.append("scanType", "");
        formData.append("categoryGuid", "74FD3D28-B288-465A-9059-4A267D030878");
        formData.append("isTemp", "true");
        formData.append("foldersGuid", "");
        formData.append("file", file);
        let response = await fileUploadApi(formData);
        if (response.success) {
          if (response.code === "0000") {
            detail.fileList.push({
              frGuid: response.frGuid,
              A_GUID: response.A_GUID,
              FileName: response.FileName,
              ImgOcr: response.ImgOcr
            });
          } else {
            this.$toast.fail(response.msg);
          }
        } else {
          this.$toast.fail("上传失败！");
        }
      },
      //全部上传完成后做如下操作
      async fileUploadFinshed(detail) {
        //此时可以自行将文件上传至服务器
        let formData = new FormData();
        formData.append("sequence", detail.GUID);
        formData.append("ocrSequence", this.guid());
        let response = await fileUploadStreamApi(formData);
      },
      /* //读取识别出来的结果填充数据
   refreshOcrQuery(detail,ocrSequence) {
     if (detail.fileList && detail.fileList !== null && detai.fileList.length > 0) {
       let websocketUrl = $("#WebSocketUrl").val();//websocket访问地址
       //利用websocket技术将OCR接口识别出来的结果推送到客户端，进行显示
       let ws = new WebSocket(websocketUrl + '?route=' + ocrSequence);//存储websocket对象
       ws.onopen = function () {
       }
       ws.onmessage = function (evt) {
         if (evt === undefined || evt === null || evt.data === undefined || evt.data === null) {
           ws.close();//断开连接
           return;
         }
         let moreUpload = $("#MoreUpload").val();
         let imageOcr = evt.data;
         let imgOcr = JSON.parse(imageOcr);
         if (imgOcr.result == undefined || imgOcr.result == null || imgOcr.result.length < 1) {
           ws.close();//断开连接
           return;
         }
         if (moreUpload == "2") {
           scanOcrResult(arrayOcr, imageOcr);
           ws.close();//断开连接
           return;
         }
         fillOcrResult(arrayOcr, imageOcr);
         ws.close();//断开连接
         return;
       }
       //如果连接出错打印出来
       ws.onerror = function (evt) {
         console.log(JSON.stringify(evt));
         ws.close();
       }
       //是否已关闭
       ws.onclose = function () {
         console.log('已经关闭');
       }
     }
   },*/
      //增加报销明细
      addDetails() {
        this.applyInfo.details.push({
          GUID: this.guid(),//生成唯一的GUID
          AffirmDate: '',//发生日期
          OrganizationName: '',//负担部门名称以','拼接字符串
          detailOrganzation: [],//负担部门存储信息
          SelectedIds: [],//负担组织存储ID集合
          InvType: '',//费用类别
          DtsInvType: '',//二级科目类别
          ShowInvType: '',//显示的详细类别
          DetailInvType: '',//三级费用类别
          detailSummary: '',//摘要
          RPer: {text: '', value: ''},//供应商/交易方
          Amount: '',//金额
          Category: {text: '', value: ''},//税种
          TaxationType: {text: '', value: ''},//税率
          TaxationAmount: '',//税费
          SumAmount: '',//含税金额
          subsidyAmt: '0',//补助
          Currency: {text: 'CNY', value: 'CNY'},//货币
          Log: '',//标记
          Log_c: '',//标记C
          State: 0,//状态
          taxTypeList: [
            {text: "请选择", value: ""}
          ],//税率列表
          uploader: [],//需要上传的文件
          fileList: [],//存储上传的文件
          //弹框对象
          showWindows: {
            showDatePicker: false,//日期弹框
            showDtsInvTypePicker: false,//详细类别弹框
            showTaxCategoryPicker: false,//税种弹框
            showTaxTypePicker: false,//税率弹框
            showSupplierPicker: false,//供应商弹框
            showCurrencyPicker: false,//货币弹框
            showBurdenDepartPicker: false,//负担部门弹框
          },
        });
        this.getDepartmentByPost(this.applyInfo.Post.value);
        if (this.applyInfo.details !== undefined && this.applyInfo.details !== null && this.applyInfo.details.length > 0) {
          this.activeNames = [this.applyInfo.details.length - 1];
        }
      },
      //移除报销明细
      removeDetails(index) {
        this.applyInfo.details.splice(index, 1);
        if (this.applyInfo.details !== undefined && this.applyInfo.details !== null && this.applyInfo.details.length > 0) {
          this.activeNames = [this.applyInfo.details.length - 1];
        }
      },
      //选择税种事件
      categoryChange(value, detail) {
        let Category = detail.Category.value;
        let sum = detail.SumAmount.replace(/,/g, "");
        let amount = detail.Amount.replace(/,/g, "");
        detail.TaxationAmount = '0'
        if (sum !== "") {
          detail.Amount = sum;
        } else {
          detail.SumAmount = amount
        }
        if (Category !== "") {
          this.getTaxTypeByCategory(value, '1').then(result => {
            detail.TaxationType.text = '';
            detail.TaxationType.value = '';
            detail.taxTypeList = result;
          });
        }
      },
      //改变税率计算数值
      taxChange(detail) {
        let taxType = detail.TaxationType.value;
        let sum = detail.SumAmount.replace(/,/g, "");
        let amount = detail.Amount.replace(/,/g, "");

        if (taxType === '') {
          detail.TaxationAmount = '0'
          if (sum != "") {
            detail.Amount = sum
          } else {
            detail.SumAmount = amount
          }
        }
        if (amount !== "") {
          this.CalcSumAmount(detail)
        } else if (sum !== "") {
          this.CalcAmount(detail);
        }
      },
      //根据金额计算总金额
      CalcAmount(detail) {
        let amount = detail.Amount.replace(/,/g, "");
        //千位符
        detail.Amount = this.Money(amount);
        let taxType = detail.TaxationType.value;
        if (taxType == '' || taxType == null) {
          detail.TaxationAmount = '0';
          detail.SumAmount = this.Money(amount);
        } else {
          this.getTaxRate(taxType).then((result) => {
            let sumAmount = (amount * (1 + result / 100)).toFixed(2);
            detail.SumAmount = this.Money(sumAmount);
            let tax = this.Money(sumAmount - amount)
            detail.TaxationAmount = tax;
          });
        }
        this.sumSumAmount();
      },
      //根据含税金额计算相关数据
      CalcSumAmount(detail) {
        //根据收入计算总金额
        let sumAmount = detail.SumAmount.replace(/,/g, '');
        //千位符
        detail.SumAmount = this.Money(sumAmount);
        let taxType = detail.TaxationType.value;
        if (taxType == '' || taxType == null) {
          detail.TaxationAmount = '0';
          detail.Amount = this.Money(sumAmount);
        } else {
          this.getTaxRate(taxType).then((result) => {
            let amount = (sumAmount / (1 + result / 100)).toFixed(2);
            detail.Amount = this.Money(amount);
            let tax = this.Money(sumAmount - amount)
            detail.TaxationAmount = tax;
          });
        }
        this.sumSumAmount();
      },
      //根据税费计算相关数据
      CalcTaxAmount(detail) {
        let TaxAmount = detail.TaxationAmount.replace(/,/g, "");
        let Amount = detail.Amount.replace(/,/g, "");
        let sumAmount = detail.SumAmount.replace(/,/g, "");
        //千位符
        detail.SumAmount = this.Money(sumAmount);
        if (TaxAmount !== "" && TaxAmount != null) {
          let amount = this.Money(sumAmount - TaxAmount);
          detail.Amount = this.Money(amount);
        }
      },
      //根据补助计算相关数据
      sumsubsidyAmt(detail) {
        let total = 0
        if (detail.subsidyAmt !== "") {
          total += parseFloat(detail.subsidyAmt);
        }
        this.applyInfo.SubsidyAmount = total;
        this.getsum();
      },
      //金额转换
      Money(price) {
        if (price > 0) {
          price = parseFloat(price).toFixed(2);
          let priceString = price.toString();
          let priceInt = parseInt(price);
          let len = priceInt.toString().length;
          let remainder = len % 3;
          let priceStr = '';
          for (let i = 1; i <= len; i++) {
            priceStr += priceString.charAt(i - 1);
            if (i == (remainder) && len > remainder) priceStr += ',';
            if ((i - remainder) % 3 == 0 && i < len && i > remainder) priceStr += ',';
          }
          if (priceString.indexOf('.') < 0) {
            priceStr = priceStr + '.00';
          } else {
            priceStr += priceString.substr(priceString.indexOf('.'));
            if (priceString.length - priceString.indexOf('.') - 1 < 2) {
              priceStr = priceStr + '0';
            }
          }
          return priceStr;
        } else {
          return price;
        }
      },
      //获取单个税种
      async getTaxRate(taxType) {
        if (this.rateInfo.value === '' || this.rateInfo.value !== taxType) {
          let companyInfo = this.getCookie("CompanyInfo");
          let params = {
            cGuid: companyInfo.companyId,
            value: taxType
          };
          let response = await getTaxOneApi(params);
          if (response.success) {
            if (response.code === "0000") {
              let data = new Object();
              data.key = taxType;
              data.value = response.result.Rate;
              this.rateInfo = {key: taxType, value: response.result.Rate};
            }
          }
        }
        return this.rateInfo.value;
      },
      //计算总金额
      sumSumAmount() {
        let total = 0;
        for (let i = 0; i < this.applyInfo.details.length; i++) {
          let row = this.applyInfo.details[i];
          let repName = "-";
          if (row.SumAmount != "") {
            total = this.addition(total, row.SumAmount);
          }
        }
        this.applyInfo.ExpensesAmount = total;
        this.getsum();
      },
      //计算出报销总费用
      getsum() {
        let Expenses = this.applyInfo.ExpensesAmount;
        let Subsidy = this.applyInfo.SubsidyAmount;
        let tatal = 0;
        tatal += parseFloat(Expenses == "" ? 0.00 : parseFloat(Expenses).toFixed(2));
        tatal += parseFloat(Subsidy == "" ? 0.00 : parseFloat(Subsidy).toFixed(2));
        this.applyInfo.TotalAmount = tatal.toFixed(2);
      },
      //提交表单
      async save() {
        this.$set(this, 'isShow', false);
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let frequeny = {
          cGuid: companyInfo.companyId,
          uGuid: userInfo.U_GUID,
          formType:this.applyInfo.FormType
        };
        let frequenyResult = await checkReimbursementFrequencyLimitApi(frequeny);
        if (frequenyResult.success) {
          if (frequenyResult.code === "0000") {
            if (frequenyResult.result && frequenyResult.result !== null && frequenyResult.result !== "") {
              if (frequenyResult.result == "0") {
                this.$toast.fail("本月报销次数已达到最大无法进行发起");
                this.$set(this, 'isShow', true);
                return;
              }
            }
            let postGuid = this.applyInfo.Post.value;
            let actApplyUGUID = this.applyInfo.ActApplyU_GUID;
            let expensesAmount = this.applyInfo.ExpensesAmount;
            let subsidyAmount = this.applyInfo.SubsidyAmount;
            let totalmount = this.applyInfo.TotalAmount;
            let approvalGuid = this.guid();
            let paylist = new Array();
            let errorMsg = "";
            for (let i = 0; i < this.applyInfo.details.length; i++) {
              let v = this.applyInfo.details[i];
              let repName = "-";
              if (v.RPer.value !== "") {
                repName = v.RPer.value;
              }
              let log = v.RPer.text;
              let log_a = "";
              this.supplierList.some((w, j) => {
                if (w.text == log) {//通过==比较数组元素是否和变量a的值相等
                  v.Log = w.value;
                  log_a = 1;
                  return true;
                }
              });
              v.Log_c = "a";
              if (log_a != 1) {
                let partner = {
                  C_GUID: companyInfo.companyId,
                };
                getPartnersAllApi(partner).then(response => {
                  if (response.success) {
                    if (response.code === "0000") {
                      let arr = new Array();
                      response.result.forEach((item, index) => {
                        let data = new Object();
                        data.value = item.BP_GUID;
                        data.text = item.Name;
                        arr.push(data);
                      });
                      let log_b = "";
                      //通过length属性获取数组长度，循环遍历数组元素
                      arr.some((x, m) => {
                        if (x.text == log) {//通过==比较数组元素是否和变量a的值相等
                          v.Log = x.value;
                          v.Log_c = "b";
                          log_b = 1;
                          return true;
                        }
                      });
                      if (log_b != 1) {
                        v.Log_c = "c";
                      }
                    }
                  }
                });
              }
              let approvalDetailGuid = v.GUID;
              let date = v.AffirmDate;
              let sumAmount = v.SumAmount.replace(/,/g, "");
              let subsidyAmt = v.subsidyAmt.replace(/,/g, "");
              let taxationType = v.TaxationType.value;
              let taxationAmount = v.TaxationAmount;
              taxationAmount = taxationAmount.replace(/,/g, "");
              let amount = v.Amount.replace(/,/g, "");
              let invType = v.InvType;
              let dtsInvType = v.DtsInvType;
              let detailInvType = v.DetailInvType;
              let remark = v.detailSummary;
              let currency = v.Currency.value;
              let payee = v.Log;
              let Log_c = v.Log_c;
              let state = v.State;
              let orginInfo = v.detailOrganzation;
              if (!orginInfo || orginInfo === null || orginInfo.length < 1) {
                errorMsg = "请选择负担组织！";
                break;
              }
              if (orginInfo.length > 1 && orginInfo.filter(o => !o.nodeamount || o.nodeamount === "" || o.nodeamount == "0") != null && orginInfo.filter(o => o.nodeamount == "" || o.nodeamount == "0").length > 0) {
                errorMsg = "负担组织金额不能含有空数据！";
                break;
              }
              let orgionArr = new Array();
              //如果只有一个负担组织的时候先判断一下是否有负担金额，如果没有的话则与不含税金额相同，如果有的话则判断是否相同
              if (orginInfo.length == 1) {
                let nodeamount = orginInfo[0].nodeamount;
                if (nodeamount === undefined || nodeamount === null || nodeamount === "" || nodeamount.length < 1 || Number(nodeamount) === 0) {
                  let orginObj = new Object();
                  orginObj.GUID = this.guid();
                  orginObj.BusinessGUID = approvalDetailGuid;
                  orginObj.DepartGUID = orginInfo[0].nodeid;
                  orginObj.DepartName = orginInfo[0].nodename;
                  orginObj.Amount = amount;
                  orginObj.Currency = currency;
                  orginObj.FormType = this.applyInfo.FormType;
                  orgionArr.push(orginObj);
                } else {
                  let orginObj = new Object();
                  orginObj.GUID = this.guid();
                  orginObj.BusinessGUID = approvalDetailGuid;
                  orginObj.DepartGUID = orginInfo[0].nodeid;
                  orginObj.DepartName = orginInfo[0].nodename;
                  orginObj.Amount = nodeamount;
                  orginObj.Currency = currency;
                  orginObj.FormType = this.applyInfo.FormType;
                  orgionArr.push(orginObj);
                }
              } else {
                orginInfo.forEach((item, index) => {
                  let nodeamount = item.nodeamount;
                  let orginObj = new Object();
                  orginObj.GUID = this.guid();
                  orginObj.BusinessGUID = approvalDetailGuid;
                  orginObj.DepartGUID = item.nodeid;
                  orginObj.DepartName = item.nodename;
                  orginObj.Amount = nodeamount;
                  orginObj.Currency = currency;
                  orginObj.FormType = this.applyInfo.FormType;
                  orgionArr.push(orginObj);
                })
              }
              let orginSumAmount = 0;//初始值为0
              orgionArr.forEach((x, y) => {
                orginSumAmount = this.addition(orginSumAmount, x.Amount);
              })
              if (parseFloat(orginSumAmount).toFixed(2) !== parseFloat(amount).toFixed(2)) {
                errorMsg = "负担总金额与金额不一致！";
                break;
              }
              //只有外币时才做这个判断
              if (currency != companyInfo.Currency) {
                let rateparams = {
                  cGuid: companyInfo.companyId,
                  fcurrency: companyInfo.Currency,
                  tcurrency: currency,
                  date: date
                };
                checkRateApi(rateparams).then(response => {
                  if (response.success) {
                    if (response.code === "0000") {
                      if (response.result === undefined || response.result === null || response.result.length < 1) {
                        errorMsg = "请添加日期汇率";
                      }
                    }
                  }
                })
                if (errorMsg !== undefined && errorMsg !== null && errorMsg !== "" && errorMsg.length > 0) {
                  break;
                }
              }
              let pay = new Object();
              pay.Approval_GUID = approvalGuid;
              pay.Approval_Sub_GUID = approvalDetailGuid;
              pay.FormType = this.applyInfo.FormType;
              pay.EventDate = date;
              pay.SumAmount = sumAmount;
              pay.Amount = amount;
              pay.Currency = currency;
              pay.RPer = payee;
              pay.Log = repName;
              pay.Log_c = Log_c;
              pay.InvType = invType;
              pay.DtsInvType = dtsInvType;
              pay.DetailInvType = detailInvType;
              pay.Remark = remark;
              pay.State = state;
              pay.Post_GUID = postGuid;
              pay.detailOrganzation = orgionArr;
              pay.TaxationType = taxationType;
              pay.TaxationAmount = taxationAmount;
              pay.SubsidyAmount = subsidyAmt;
              pay.C_GUID = companyInfo.companyId;
              if ((pay.InvType === "" || pay.InvType === null) && (pay.DtsInvType === null || pay.DtsInvType === "")) {
                pay.InvType = '未归类';
                pay.DtsInvType = '';
              }
              paylist.push(pay);
            }
            if (errorMsg && errorMsg !== null && errorMsg !== "") {
              this.$toast.fail(errorMsg);
              this.$set(this, 'isShow', true);
              return;
            }
            let approvalFormInfo = new Object();
            approvalFormInfo.Approval_GUID = approvalGuid;
            approvalFormInfo.FormType = this.applyInfo.FormType;
            approvalFormInfo.Post_GUID = postGuid;
            approvalFormInfo.Act_U_GUID = (actApplyUGUID !== undefined && actApplyUGUID !== null && actApplyUGUID !== "" && userInfo.U_GUID === actApplyUGUID ? "" : actApplyUGUID);
            approvalFormInfo.InvType = '';
            approvalFormInfo.ExpensesAmount = expensesAmount;
            approvalFormInfo.SubsidyAmount = subsidyAmount;
            approvalFormInfo.Amount = totalmount;
            approvalFormInfo.Remark = this.applyInfo.summary;
            approvalFormInfo.C_GUID = companyInfo.companyId;
            approvalFormInfo.U_GUID = userInfo.U_GUID;
            approvalFormInfo.Creator = userInfo.NickName;
            approvalFormInfo.CompanyName = companyInfo.companyName;
            approvalFormInfo.UserName = userInfo.TelName || userInfo.LoginName;
            approvalFormInfo.ApplyName = userInfo.NickName || (userInfo.FirstName + userInfo.LastName);
            approvalFormInfo.detailLists = paylist;
            let params = {
              ...approvalFormInfo
            };
            submitApplyFormApi(params).then(response => {
              if (response.success) {
                this.$set(this, 'isShow', true);
                if (response.code === "0000") {
                  this.$router.push({path: "/follow"})
                  return;
                }
                return;
              }
              this.$set(this, 'isShow', true);
              return;
            });
          }
        }

      }
    }
  }
</script>

<style lang="less" scoped>
  .wrapper {
    height: calc(100vh - 5rem);
    ::v-deep.van-hairline--top-bottom{
      .van-remove-detail-items {
        position: relative;
        height: 100%;
        .van-remove-detail {
          display: flex;
          position: absolute;
          right: 3rem;
          z-index: 5;
          text-align: center;
          align-items: center;
          padding: 10px 16px;
          line-height: 24px;
          color: #0066ff;
          font-size: 1.4rem;
          .iconfont-style{
            font-size:1.1rem;
          }
        }
      }
    }
    .add-detail {
      color: #0066ff;
      text-align: center;
      padding: 1rem 0;
      font-size: 1.4rem;
    }
    ::v-deep.van-collapse-item__content {
      padding: 0;
    }

    ::v-deep.van-collapse-item__title {
      background: #f6f6f8;
    }

    .total {
      padding: 1rem;
      background: #f6f6f8;
      font-size: 14px;
      .title {
        color: #bababb;
        font-size: 14px;
      }

      .value {
        color: #323332;
        text-align: right;
        font-size: 14px;
      }
      .text-muted{
        font-size: 14px;
      }
    }

    .buttons {
      margin: 1rem;
      display: flex;

      button {
        border-radius: 1rem;
        flex: 1;
      }
    }
    .van-field{
      ::v-deep.van-field__label{
        width:6.5em;
      }
      ::v-deep.van-field__error-message{
        text-align: right;
      }
    }
    .van-field_dosth{
      height: 100%;
    }
    .van-popup{
      height: 40%;
    }
    .popup-header {
      position: sticky; /* 使头部悬浮 */
      top: 0; /* 固定在顶部 */
      background-color: white; /* 背景色 */
      z-index: 10; /* 确保层级 */
      padding: 10px; /* 内边距 */
      border-bottom: 1px solid #eee; /* 底部边框 */
    }
    .popup-content {
      height: calc(100% - 40px); /* 减去头部高度 */
    }
    .agency-title {
      padding: 2rem 0;
      font-size: 1.8rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 2rem;
      text-align: center;
    }

    .agency-box {
      margin: 1.2rem 0;
      .th-row {
        height: 5.6rem;
        line-height: 5.6rem;
        background: #ebf1f7;
        padding: 0 1.2rem;
      }
      .tb-row {
        height: 5.6rem;
        line-height: 5.6rem;
        padding: 0 1.2rem;
        display: flex;
        justify-content: space-between !important;
      }
      .van-col{
        width:20%;
        text-align: center;
        font-size: 1.5rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    ::v-deep {
      .my-popup.van-popup--bottom.van-popup--round {
        border-radius: 10px 10px 0 0;
      }
      .van-select {
        overflow: initial;
      }
    }
    ::v-deep.row {
      overflow: initial;
      width:95%;
      margin:0 auto 2rem;
      padding-bottom: 14px;
      clear: both;
      .row-container{
        width:100%;
        clear: both;
        overflow: hidden;
      }
      .row-border{
        width: 100%;
        overflow: hidden;
        border:solid 1px #ccc;
      }
      .modal-header {
        position: sticky; /* 使头部悬浮 */
        top: 0; /* 固定在顶部 */
        background-color: white; /* 背景色 */
        z-index: 10; /* 确保层级 */
        padding: 10px; /* 内边距 */
        border-bottom: 1px solid #eee; /* 底部边框 */
      }
      .col-md-left{
        width:80%;
        float: left;
      }
      .col-md-right{
        width:20%;
        float: right;
      }
      .a-link{
        display: block;
        width: 100%;
      }
      .a-button {
        position: relative;
        display: inline-block;
        box-sizing: border-box;
        height: 44px;
        margin: 0;
        padding: 0;
        font-size: 16px;
        line-height: 44px;
        text-align: center;
        border-radius: 2px;
        cursor: pointer;
        -webkit-transition: opacity 0.2s;
        transition: opacity 0.2s;
        -webkit-appearance: none;
      }
      .a-button::before {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        background-color: #000;
        border: inherit;
        border-color: #000;
        border-radius: inherit;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        opacity: 0;
        content: ' ';
      }
      .modal-title {
        padding: 0.5rem 0;
        font-size: 1.6rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333;
        text-align: center;
      }
    }
    ::v-deep.modal-footer {
      position: fixed;
      width:100%;
      bottom: 0;
      right: 0;
      z-index: 9999;
      padding: 12px 15px 12px 15px !important;
      border-top: solid 1px #e2e2e2 !important;
      text-align: right;
      .modal-footer::before {
        display: table;
        content: "";
      }
      .wc-btn {
        display: inline-block;
        padding: 0 10px;
        height: 30px;
        line-height: 28px;
        border-width: 1px;
        border-style: solid;
        font-size: 12px;
        box-sizing: border-box;
        outline: none;
        white-space: nowrap;
      }
      .wc-btn-primary {
        color: white;
        background-color: #217346;
        border-color: #217346;
      }
      .wc-btn-primary.ghost {
        background-color: white;
        color: #217346;
        margin-left: 6px;
      }
    }
    ::v-deep.row::before {
      display: table;
      content: "";
    }
  }
</style>
